var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBundleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13_53926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 10V23.75H23.75V10H20V20L15 17.5L10 20V10H6.25ZM6.25 26.25C5.5625 26.25 4.97396 26.0052 4.48438 25.5156C3.99479 25.026 3.75 24.4375 3.75 23.75V8.15625C3.75 7.86458 3.79688 7.58333 3.89062 7.3125C3.98438 7.04167 4.125 6.79167 4.3125 6.5625L5.875 4.65625C6.10417 4.36458 6.39062 4.14062 6.73438 3.98438C7.07812 3.82812 7.4375 3.75 7.8125 3.75H22.1875C22.5625 3.75 22.9219 3.82812 23.2656 3.98438C23.6094 4.14062 23.8958 4.36458 24.125 4.65625L25.6875 6.5625C25.875 6.79167 26.0156 7.04167 26.1094 7.3125C26.2031 7.58333 26.25 7.86458 26.25 8.15625V23.75C26.25 24.4375 26.0052 25.026 25.5156 25.5156C25.026 26.0052 24.4375 26.25 23.75 26.25H6.25ZM6.75 7.5H23.25L22.1875 6.25H7.8125L6.75 7.5ZM12.5 10V15.9375L15 14.6875L17.5 15.9375V10H12.5Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBundleIcon);
export default __webpack_public_path__ + "static/media/bundle-icon.4897c5ab62e9030ee4b766e1ed22b4f9.svg";
export { ForwardRef as ReactComponent };